import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { FOR_YOU_ITEMS } from '../../data/content';
export function ForYou() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-106" data-mp="323w17d83ta35">
      <div className="mx-auto max-w-3xl" data-id="element-107" data-mp="2obpmzwoihd6c">
        <Reveal className="text-center" data-id="element-108" data-mp="2o8tkrw5ms2c3">
          <h2 className="font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-109" data-mp="2t8y5xzhhhl8n">
            MegaPack Árabe PRO <span className="u-lime" data-id="element-110" data-mp="3h0db000nagnl">es para vos si...</span>
          </h2>
        </Reveal>

        <Reveal delay={90} className="mt-8" data-id="element-111" data-mp="3l1702wptq1i2">
          <ul className="grid gap-x-8 gap-y-0 rounded-2xl border border-ink-line bg-ink px-5 py-2 sm:grid-cols-2 sm:px-6" data-id="element-112" data-mp="3kyt50nv58pai">
            {FOR_YOU_ITEMS.map(item => <li key={item} className="flex items-start gap-3 border-b border-ink-line py-3.5 text-sm font-medium leading-snug text-snow sm:text-base" data-id="element-113" data-mp="3bzfv5u33xyp9">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-lime" aria-hidden="true" data-id="element-114" data-mp="1vo20gc3okch2" />
                {item}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}